module.exports = __webpack_public_path__ + "img/userMenu-profile.f729993b.svg";